'use strict';

angular
    .module('attractions')
    .service('attractionDetailsService', attractionDetailsService);


function attractionDetailsService($http, $cacheFactory, $q) {

    var url = '/api2/attractions/details/',
        timeout,
        cacheLabel = 'detailPromiseCache',
        promiseCache = $cacheFactory.get(cacheLabel) || $cacheFactory(cacheLabel);

    var imageUrl = TRPCONFIG.Domain.AttractionsImageUrl;
    // var domain = TRPCONFIG.Domain,
    var service = {
        getAttractionDetails,
        getImageUrl,
        rehydrate,
        purge
    };

    function enhanceData(data) {
        data.AttractionIds = [];
        angular.forEach(data.AttractionRequests, function (r, k) {
            data.AttractionIds.push(parseInt(k, 10));
        });
        return data;
    }

    function getAttractionDetails(productDetails) {
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        timeout = $q.defer();
        return $http.post(url + 'get', productDetails, { ignoreErrors: true, timeout: timeout.promise })
            .then(function (res) {
                promiseCache.remove(res.data.DetailsSearchId);
                timeout = null;
                return enhanceData(res.data);
            });
    }

    function rehydrate(detailsSearchId) {
    // Retrieve product details from session
        if (!promiseCache.get(detailsSearchId)) {
            promiseCache.put(
                detailsSearchId,
                $http.post(url + 'getfromsession', { DetailsSearchId: detailsSearchId }, { ignoreErrors: true })
                    .then((res) => enhanceData(res.data))
            );
        }
        return promiseCache.get(detailsSearchId);
    }

    function purge() {
        $cacheFactory.get(cacheLabel).removeAll();
    }

    function getImageUrl(id) {
        return imageUrl + id;
    }

    return service;

}
